import React from 'react';
import './Common.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>AVO Protocol</h4>
          <p>Advanced blockchain explorer</p>
        </div>
        <div className="footer-section">
          <h4>Network</h4>
          <p>RPC: localhost:9545</p>
          <p>Chain ID: 1337</p>
        </div>
        <div className="footer-section">
          <h4>Status</h4>
          <p className="status-text status-ok">All systems operational</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 AVO Protocol Explorer. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;